import { RadioTileGroup } from '@noissue-ui-kit/oldBranding/radioTile'
import { useEditorFullScreenMode } from '@pageFeatures/design/UnifiedEditorProvider'
import { HiOutlineCog } from 'react-icons/hi'
import { SettingsControl } from './SettingsControl'

export function SettingsButton({
  showSettings,
  setShowSetting,
}: {
  showSettings: boolean
  setShowSetting: () => void
}) {
  const { isFullScreen } = useEditorFullScreenMode()

  const radioTileButtonOption = {
    displayLabel: (
      <div className="flex items-center">
        <HiOutlineCog className="w-[24px] h-[24px] mr-3" />
        <span className="font-semibold">Settings</span>
      </div>
    ),
    key: 'settings',
  }

  return (
    <>
      <RadioTileGroup
        onChange={setShowSetting}
        options={[radioTileButtonOption]}
        radioGroupClassName={`grid-cols-1 w-full sm:w-[120px] ${
          !isFullScreen && 'ml-auto'
        }`}
        selected={showSettings ? { ...radioTileButtonOption } : null}
        radioItemClassName="hover:bg-black-10"
      />
      {showSettings && (
        // For mobile view
        <div className="w-full sm:hidden">
          <SettingsControl />
        </div>
      )}
    </>
  )
}
